import React from "react";
import { DivColumn, DivRow, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsImages from "../../../constants/ConstantsImages";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";
import "./WidgetAlertDialogSubjectiveChangeSuccess.css";

const WidgetAlertDialogSubjectiveChangeSuccess = ({ onClose, messageText, checkIconProp, iconSize = "2.7rem" }) => {
  return (
    <div className="alert-dialog-subjective-change-overlay" onClick={onClose}>
      <DivColumn className="alert-dialog-subjective-change-success" onClick={(event) => event.stopPropagation()}>
        <DivRow className="alert-dialog-subjective-change-success-close-row">
          <button type="button" className="alert-dialog-subjective-change-success-close" onClick={onClose} aria-label="סגירה">
            <WidgetIconFive iconProp={ConstantsImages.PENDING_REQUESTS_CLOSE_IMAGE} widthIconProp="1rem" heightIconProp="1rem" />
          </button>
        </DivRow>

        <WidgetIconFive
          iconProp={checkIconProp || ConstantsImages.APPROVE_IMAGE}
          widthIconProp={iconSize}
          heightIconProp={iconSize}
        />

        <ParagraphText className="alert-dialog-subjective-change-success-message">{messageText}</ParagraphText>
      </DivColumn>
    </div>
  );
};

export default WidgetAlertDialogSubjectiveChangeSuccess;
